import React from "react";
import { percentOf } from "./chartTheme";

/**
 * Shared recharts tooltip. Every chart in the report ships one - an SVG chart
 * is interactive by default, and the tooltip is what carries the values we
 * deliberately do not label directly.
 */
export default function ChartTooltip({ active, payload, label, total, valueLabel = "Applicants" }) {
  if (!active || !payload || !payload.length) return null;

  const rows = payload.filter((p) => p?.value !== null && p?.value !== undefined);
  if (!rows.length) return null;

  return (
    <div className="viz-tooltip">
      <div className="viz-tooltip-label">{label ?? rows[0]?.name}</div>
      {rows.map((row, i) => (
        <div className="viz-tooltip-row" key={i}>
          <span
            className="viz-legend-swatch"
            style={{ background: row?.payload?.fill || row?.color }}
          />
          <span>{row?.name || valueLabel}</span>
          <span className="viz-tooltip-value">
            {row.value}
            {total ? ` · ${percentOf(row.value, total)}` : ""}
          </span>
        </div>
      ))}
    </div>
  );
}
